import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const gsapAnimations = {
  parallax: function() {
    // example: https://codepen.io/GreenSock/pen/QWjjYEw
    if ($(window).width() > 992) {
      gsap.utils.toArray("section").forEach((section, i) => {
        section.bg = section.querySelector(".parallax-content"); 
        if(section.bg) {
          // Do the parallax effect on each section
          if (i) {
            section.bg.style.backgroundPosition = `50% ${-innerHeight / 2}px`;

            gsap.to(section.bg, {
              backgroundPosition: `50% ${innerHeight / 2}px`,
              ease: "none",
              scrollTrigger: {
                trigger: section,
                scrub: true,
              },
            });
          }
        }
      });
    }
  },
};

document.addEventListener("DOMContentLoaded",function() {
  gsapAnimations.parallax();
})



// WEBPACK FOOTER //
// ./scripts/modules/_gsap-animation.js